import React, { useEffect, useState } from "react";
import "../../global.css";
import "./crew.css";
import { useMediaQuery } from "react-responsive";
import { IoReorderThreeOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import ContentCard from "../../components/contentcard/ContentCard";
import UserDetailsModal from "../../components/userdetailsmodal/UserDetailsModal";
import { useDispatch, useSelector } from "react-redux";
import { setContent } from "../../redux/contentSlice";
import { useTranslate } from "../../utils/useTranslate";

const Crew = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [crews, setCrews] = useState([]);

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [userDetails, setUserDetails] = useState({});
  const [userModalOpen, setUserModalOpen] = useState(false);

  const { language } = useSelector((state) => state.language);
  const { isOpenContentsModal } = useSelector((state) => state.content);

  useEffect(() => {
    dispatch(setContent(null));
  }, [dispatch]);

  useEffect(() => {
    if (language.value === "en") {
      fetch("/assets/datas/crews.json")
        .then((res) => res.json())
        .then((data) => {
          setCrews(shuffleArray(data));
        });
    } else {
      fetch("/assets/datas/tr-crews.json")
        .then((res) => res.json())
        .then((data) => {
          setCrews(shuffleArray(data));
        });
    }
  }, [language]);

  const [contents, setContents] = useState([]);

  useEffect(() => {
    if (language.value === "en") {
      fetch("/assets/datas/contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    } else {
      fetch("/assets/datas/tr-contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    }
  }, [language]);

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; // Değiş tokuş yapma
    }
    return shuffled;
  };

  return (
    <div className="globalContainer crewContainer">
      <div
        className="crewLeftContainer"
        style={{
          width: isOpenContentsModal === false && isMobile === false && "96%",
        }}
      >
        <div className="crewLeftSubContainer">
          <div className="crewLeftSubAltContainer">
            <span className="textFlex crewTitleStyle">
              {language.value === "tr"
                ? translate("crew").toLocaleUpperCase("tr-TR")
                : translate("crew").toLocaleUpperCase("en-US")}
            </span>
          </div>
        </div>
        <div
          className="crewLeftBottomContainer"
          style={{
            gridTemplateColumns:
              isOpenContentsModal === false &&
              isMobile === false &&
              "repeat(4, 1fr)",
          }}
        >
          {crews?.map((item, index) => (
            <div
              key={index}
              style={{
                width: "100%",
                minHeight: isMobile === false && "388px",
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "column",
                gap: "20px",
                marginBottom: "40px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  minHeight: isMobile === false && "320px",
                  maxHeight: "320px",
                  objectFit: "cover",
                  cursor: "pointer",
                  borderRadius: "8px",
                  border: "1px solid #100F0D",
                }}
                alt=""
                src={`/assets/images/${item?.imageName}`}
                onClick={() => {
                  setUserDetails(item);
                  setUserModalOpen(true);
                }}
              />
              <div
                style={{
                  maxWidth: "305px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <span
                  className="textFlex"
                  style={{
                    fontWeight: "600",
                    fontSize: "20px",
                    color: "#100F0D",
                    textTransform: "uppercase",
                  }}
                >
                  {language.value === "tr"
                    ? item?.fullName.toLocaleUpperCase("tr-TR")
                    : item?.fullName.toLocaleUpperCase("en-US")}
                </span>
                <span
                  className="textMono"
                  style={{
                    fontWeight: "400",
                    fontSize: "14px",
                    color: "#100F0D",
                    lineHeight: "140%",
                    textTransform: "uppercase",
                  }}
                >
                  {language.value === "tr"
                    ? item?.profession.toLocaleUpperCase("tr-TR")
                    : item?.profession.toLocaleUpperCase("en-US")}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <UserDetailsModal
        isOpen={userModalOpen}
        onClose={() => setUserModalOpen(false)}
        user={userDetails}
      />
      {isOpenContentsModal === true && isMobile === false ? (
        <div className="crewRightContainer">
          <div className="crewRightSubContainer">
            <span className="textMono allContentTextStyle">
              {language.value === "tr"
                ? translate("allContent").toLocaleUpperCase("tr-TR")
                : translate("allContent").toLocaleUpperCase("en-US")}
            </span>
            <hr className="crewRightDivHr" />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              overflowY: "scroll",
              gap: "10px",
            }}
          >
            {contents.map((item) => (
              <ContentCard item={item} isHome={false} key={item.id} />
            ))}
          </div>
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("allContent").toLocaleUpperCase("tr-TR")
                  : translate("allContent").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : isMobile === true && isOpenModal === false ? (
        <div className="crewRightContainer">
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
              onClick={() => setIsOpenModal(true)}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("allContent").toLocaleUpperCase("tr-TR")
                  : translate("allContent").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : (
        isMobile === true && (
          <div className="customModalOverlay">
            <div className="customModalContainer">
              <div
                className="crewRightContainer"
                style={{
                  height: "70vh",
                }}
              >
                <div className="crewRightSubContainer">
                  <span className="textMono allContentTextStyle">
                    {language.value === "tr"
                      ? translate("allContent").toLocaleUpperCase("tr-TR")
                      : translate("allContent").toLocaleUpperCase("en-US")}
                  </span>
                  <hr className="crewRightDivHr" />
                </div>
                <div className="modalScrollableContent">
                  {contents.map((item) => (
                    <ContentCard item={item} key={item.id} />
                  ))}
                </div>

                {isMobile && (
                  <button
                    className="allContentMobileStyle"
                    style={{ textDecoration: "none" }}
                    onClick={() => setIsOpenModal(false)}
                  >
                    <IoCloseOutline
                      style={{ fontSize: "18px", color: "#100F0D" }}
                    />
                    <span className="linkTextStyle textMono">
                      {language.value === "tr"
                        ? translate("allContent").toLocaleUpperCase("tr-TR")
                        : translate("allContent").toLocaleUpperCase("en-US")}
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default Crew;
